var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.dataItem.safe)?_c('b-list-group-item',[_c('div',{staticClass:"font-weight-bold text-primary"},[_vm._v(" Kasa Hesabı ")]),_c('div',[_vm._v(_vm._s(_vm.dataItem.safe))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }